import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import SnugPiercingImage from '../../Assets/Piercing Services/snug piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function SnugPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Snug Piercing UAE | 200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Snug Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Snug Piercing 200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={SnugPiercingImage} alt="Snug Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Snug Piercing</h3>

          <p>
            Make a bold and distinctive style statement with our professional snug piercing services in the UAE, available at an affordable price of 200 AED. Snug piercing is an uncommon and eye-catching ear piercing placed on the inner cartilage ridge, running parallel to the outer ear rim. This unique placement creates a striking and edgy look that stands out from traditional ear piercings, making it a perfect choice for individuals who want to express their individuality with confidence. Whether you prefer a curved barbell or a minimal jewelry piece, our expert specialists ensure precise placement for a balanced and visually appealing result that enhances your overall ear design.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each snug piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Due to its placement in the inner cartilage, snug piercing requires advanced skill and expertise, and our experienced specialists are trained to perform the procedure accurately while minimizing discomfort.
          </p>

          <p>
            Snug piercing is ideal for those who want a bold and unique ear style that truly stands out. Its inner-ear position gives it a distinctive look that pairs beautifully with other piercings such as helix, conch, tragus, or lobe, allowing you to create a curated and layered ear aesthetic. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your ear anatomy and personal style. This personalized approach ensures that your piercing complements your overall appearance perfectly.
          </p>

          <p>
            The procedure is typically completed within minutes, though it requires careful handling due to its location. Our team uses advanced techniques designed to reduce pain and promote faster healing, ensuring that you can enjoy your new piercing with minimal discomfort. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensure a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that uncommon cartilage piercings like the snug can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your snug piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your snug piercing will heal effectively and remain a stylish and long-lasting feature of your ear design.
          </p>

          <p>
            Our snug piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted snug piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a bold and uncommon ear look effortlessly. Book your snug piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Snug Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SnugPiercing;